import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "feedback-form" }
const _hoisted_2 = {
  key: 0,
  class: "feedback-content"
}
const _hoisted_3 = {
  key: 0,
  class: "alert alert-success"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "captcha-container" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SReCaptcha = _resolveComponent("SReCaptcha")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "feedback-header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded))
    }, [
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "feedback-title" }, [
        _createElementVNode("i", { class: "fas fa-comment-alt" }),
        _createTextVNode(" Geef feedback ")
      ], -1)),
      _createElementVNode("i", {
        class: _normalizeClass(['fas', _ctx.isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'])
      }, null, 2)
    ]),
    (_ctx.isExpanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.submitSuccess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Bedankt voor uw feedback! "))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.feedback) = $event)),
                  placeholder: "Uw opmerking...",
                  rows: "3",
                  class: "form-control",
                  disabled: _ctx.isSubmitting
                }, null, 8, _hoisted_5), [
                  [_vModelText, _ctx.feedback]
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_SReCaptcha, {
                    ref: "recaptcha",
                    onOnRecaptchaTokenResponse: _ctx.onCaptchaVerified
                  }, null, 8, ["onOnRecaptchaTokenResponse"])
                ]),
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitFeedback && _ctx.submitFeedback(...args))),
                  disabled: !_ctx.canSubmit || _ctx.isSubmitting,
                  class: "btn btn-primary btn-sm"
                }, [
                  (_ctx.isSubmitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1),
                        _createTextVNode(" Verzenden... ", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "fas fa-paper-plane" }, null, -1),
                        _createTextVNode(" Verstuur ", -1)
                      ]))]))
                ], 8, _hoisted_8)
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}